import React from 'react';
import clsx from 'clsx';
import ClickedNewPagePopUp from '../PopUpsValidations/ClickedNewPagePopUp';
import ValidationClickedNewPage from '../PopUpsValidations/ValidationClickedNewPage';

const NewPageButton = (props) => {

    const {
        editor,
        selectedPage,
        selectedProject,
        savedPagesPerProject,
        newPageClicked,
        savedPageClicked
    } = props;

    const [clickedNewPage, setClickedNewPage] = React.useState(false);
    const [openClickedNewPageValidation, setOpenClickedNewPageValidation] = React.useState(false);

    const createNewPage = () => {
      
        if(editor.Commands.isActive('view-annotations') === false){
          if (savedPagesPerProject[selectedProject][selectedPage] !== false) {
            setClickedNewPage(true);
          } else {
            setOpenClickedNewPageValidation(true);
          }
        }
    };

    return(
        <>
            <div
                id='newPageButton'
                data-tooltip="New page"
                data-tooltip-pos="bottom"
                aria-hidden="true"
                className={
                selectedPage > -1
                    ? clsx('fa', 'fa-plus', 'gjs-pn-btn', 'gjs-pn-btn4')
                    : clsx('fa', 'fa-plus', 'gjs-pn-btn3', 'gjs-pn-btn', 'gjs-new-width')
                }
                onClick={createNewPage}
            >
                {' '}
            </div>
            <ClickedNewPagePopUp
                clickedNewPage={clickedNewPage}
                setClickedNewPage={setClickedNewPage}
                selectedProject={selectedProject}
                newPageClicked={newPageClicked}
            />
            <ValidationClickedNewPage
                openAlert={openClickedNewPageValidation}
                setOpenAlert={setOpenClickedNewPageValidation}
                newPageClicked={newPageClicked}
                savedPageClicked={savedPageClicked}
                selectedProject={selectedProject}
                selectedPage={selectedPage}
            />
        </>
    )

}

export default NewPageButton ;